import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ExportButton extends Component {
  constructor(props) {
    super(props);
    this.handleExportClick = this.handleExportClick.bind(this);
  }

  handleExportClick() {
    const {selectedPart, initialDate, finalDate, reason, partCode, agency, user, dealer} = this.props;
    this.props.getPartLostSalesReport(selectedPart.partCode, {
      initialDate, finalDate, reason, partCode, agency, user, dealer,
    });
  }

  render() {
    const {downloading} = this.props;

    return (
      <Button primary
        content='EXPORTAR A EXCEL'
        disabled={downloading}
        loading={downloading}
        onClick={this.handleExportClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'downloading': state.lostSalesReportDetail.exportingDetail,
    'selectedPart': state.lostSalesReportDetail.selectedPart,
    'initialDate': state.lostSalesReportDetail.initialDate,
    'finalDate': state.lostSalesReportDetail.finalDate,
    'dealer': state.lostSalesReportDetail.dealer,
    'agency': state.lostSalesReportDetail.agency,
    'user': state.lostSalesReportDetail.user,
    'reason': state.lostSalesReportDetail.reason,
  };
};

const {getPartLostSalesReport} = Actions;

export default connect(mapStateToProps, {
  getPartLostSalesReport,
})(ExportButton);
